/* eslint-disable no-nested-ternary */
import React, { type ReactNode, useContext } from 'react'
import Placeholder from '../../../Atoms/Placeholder'
import Typography from '../../../Atoms/Typography'
import { CardContext } from '..'

import styles from './index.module.css'

interface ITitleProps {
  children: ReactNode
}

export const Title = (props: ITitleProps) => {
  const { children } = props
  const { matches, variant } = useContext(CardContext)

  const typographyProps = matches.large ? { variant: 'title', size: 'xs' } as const: // prettier-ignore
                  matches.medium ? { variant: 'title', size: 'xs' } as const :       // prettier-ignore
                  matches.small ? { variant: 'body', size: 'l' } as const :          // prettier-ignore
                  { variant: 'body', size: 'l' } as const // prettier-ignore

  const linesToClamp = variant === 'lite' ? 2 : 3

  return (
    <div className={styles.title}>
      <Typography {...typographyProps} clamp={linesToClamp} bold>
        {children}
      </Typography>
    </div>
  )
}

Title.displayName = 'Card.Title'

function TitlePlaceholder() {
  return <Placeholder.Text lines={1} lineHeight="27px" />
}
TitlePlaceholder.displayName = 'Card.Title.Placeholder'

Title.Placeholder = TitlePlaceholder
